import './workout-feedback.css';
import React, {useEffect, useRef, useState} from "react";
import {createWorkoutFeedbackData} from "../../store/slices/workoutFeedback";
import TimerHeartbeats from "../../components/TimerHeartbeats/TimerHeartbeats";
import WorkoutPopupMessage from '../../components/WorkoutPopupMessage/WorkoutPopupMessage';
import ServerRequest from "../../ServerRequests/ServerRequest";
import {ReactComponent as WorkoutContentLogoFeedback} from './workout-feedback-img/main-img.svg';
import {useDispatch, useSelector} from "react-redux";


const WorkoutFeedback = () => {
  const feelingEstimationRef = useRef(null);
  const workoutEstimationRef = useRef(null);
  const inputHeartBeatsRef = useRef(null);
  const feelingContainerRef = useRef(null);
  const workoutContainerRef = useRef(null);
  const heartbeatsContainerRef = useRef(null);
  const feedbackErrorRef = useRef(null);
  const pulseInputErrorRef = useRef(null);
  const localWorkoutSetupData = JSON.parse(localStorage.getItem('workoutSetupData')) ?? null;
  const [feelingEstimationValue, setFeelingEstimationValue] = useState('');
  const [workoutEstimationValue, setWorkoutEstimationValue] = useState('');
  const [heartBeatsValue, setHeartBeatsValue] = useState('');
  const userID = localStorage.getItem('userHash') ?? null;
  const userProfileData = JSON.parse(localStorage.getItem(userID))?.userProfileData ?? null;
  const [isPopupShown, setIsPopupShown] = useState(false);
  const workoutFeedbabackRef = useRef(null);
  const timerFadeIn = useRef(null);
  const dispatch = useDispatch();


  const handleBlur = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  };


  useEffect(() => {
    if (workoutFeedbabackRef.current) {
      workoutFeedbabackRef.current.classList.add('workout-feedback-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      workoutFeedbabackRef.current.classList.remove('workout-feedback-fade-in');
    }, 350)

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);

  const handleChooseItem = (e) => {
    if (e.target.dataset.feelingEstimation) {
      Array.from(feelingEstimationRef.current.children).map(item => {
        item.classList.remove('chosen-feedback');
      })
      e.target.classList.add('chosen-feedback');
      setFeelingEstimationValue(e.target.dataset.feelingEstimation);
    } else if (e.target.dataset.workoutEstimation) {
      Array.from(workoutEstimationRef.current.children).map(item => {
        item.classList.remove('chosen-feedback');
      })
      e.target.classList.add('chosen-feedback');
      setWorkoutEstimationValue(e.target.dataset.workoutEstimation);
    }
  }

  const handleChangePulse = (e) => {
    let value = e.target.value;

    if (value.startsWith('0')) {
      value = value.slice(1);
    }

    if (value.length <= 3) {
      setHeartBeatsValue(value.replace(/[^0-9]/g, ''));
    }
  }

  const handleSendUserResponse = () => {
    if (!feelingEstimationValue) {
      feelingContainerRef.current.classList.add('error-field');
    } else {
      feelingContainerRef.current.classList.remove('error-field');
    }

    if (!workoutEstimationValue) {
      workoutContainerRef.current.classList.add('error-field');
    } else {
      workoutContainerRef.current.classList.remove('error-field');
    }

    if (heartBeatsValue < 40) {
      heartbeatsContainerRef.current.classList.add('error-field');
      pulseInputErrorRef.current.classList.add('pulse-input-error--shown');
    } else {
      heartbeatsContainerRef.current.classList.remove('error-field');
      pulseInputErrorRef.current.classList.remove('pulse-input-error--shown');
    }

    if (!feelingEstimationValue || !workoutEstimationValue || (!heartBeatsValue || heartBeatsValue < 40)) {
      feedbackErrorRef.current.classList.add('feedback-error-shown')
    } else {
      feedbackErrorRef.current.classList.remove('feedback-error-shown')
    }

    if (feelingEstimationValue && workoutEstimationValue && heartBeatsValue && heartBeatsValue >= 40) {
      setIsPopupShown(true);
    }
  }

  useEffect(() => {
    if (feelingEstimationValue) {
      feelingContainerRef.current.classList.remove('error-field');
    }

    if (workoutEstimationValue) {
      workoutContainerRef.current.classList.remove('error-field');
    }

    if (heartBeatsValue) {
      heartbeatsContainerRef.current.classList.remove('error-field');

      if (heartBeatsValue < 40) {
        pulseInputErrorRef.current.classList.add('pulse-input-error--shown');
      } else {
        pulseInputErrorRef.current.classList.remove('pulse-input-error--shown');
      }
    }

    if (feelingEstimationValue && workoutEstimationValue && heartBeatsValue) {
      feedbackErrorRef.current.classList.remove('feedback-error-shown')
    }
  }, [feelingEstimationValue, workoutEstimationValue, heartBeatsValue]);

  useEffect(() => {
    if (feelingEstimationValue && workoutEstimationValue && heartBeatsValue && isPopupShown) {
      dispatch(createWorkoutFeedbackData(
        {
          difficultyExercise: localWorkoutSetupData ? localWorkoutSetupData['difficulty'] : '',
          exerciseNameLocal: localWorkoutSetupData ? localWorkoutSetupData["exerciseNameLocal"] : '',
          exerciseName: localWorkoutSetupData ? localWorkoutSetupData["exerciseName"] : '',
          feelingEstimation: feelingEstimationValue,
          workoutEstimation: workoutEstimationValue,
          heartBeatsEstimation: heartBeatsValue,
          isRecordedUserResponse: isPopupShown,
          date: new Date().toISOString().split('T')[0],
        }
      ))
    }
  }, [feelingEstimationValue, workoutEstimationValue, heartBeatsValue, isPopupShown]);

   const workoutFeedback = useSelector(
    state => state.workoutFeedbackData
  );


  useEffect(() => {
    if (!userID) return;

    const localData = JSON.parse(localStorage.getItem(userID)) ?? {};
    localData.workoutFeedbackData = workoutFeedback;

    localStorage.setItem(userID, JSON.stringify(localData));
  }, [workoutFeedback, userID]);


  useEffect(() => {
    const sendWorkoutData = async () => {
      const todayWorkoutData = workoutFeedback ? workoutFeedback.map(item => {
        if (item.date === new Date().toISOString().split('T')[0]) {
          return {...item, userHash: userID};
        }
        return item;
      }).find(item => item.date === new Date().toISOString().split('T')[0]) : null;

      try {
        await ServerRequest.sendWorkoutFeedbackData(todayWorkoutData, userID);
      } catch (error) {
        console.error("Error sending user response by workout:", error);
      }
    }

    (async () => {
      await sendWorkoutData();
    })();
  }, [workoutFeedback]);

  return (
    <div ref={workoutFeedbabackRef}
         className='workout-container-feedback'>
      <p className='workout-container__title-feedback'>
        {localWorkoutSetupData["exerciseNameLocal"]}
      </p>
      <div className='workout-content-feedback'>
        <WorkoutContentLogoFeedback className="workout-content-logo-feedback"
                                    width='131'
                                    height='134'/>
        <div className='workout-feedback-form'>
          <div ref={feelingContainerRef}
               className={`feeling-estimation-container`}>
            <p className='feeling-estimation-title'>Ako sa cítite?</p>
            <div ref={feelingEstimationRef}
                 className='feeling-estimation-sub-container'>
              <div
                onClick={handleChooseItem}
                data-feeling-estimation='Not well'
                className='feeling-estimation-item'>
                <div className='feeling-estimation-item__inner'>
                  <img className='feeling-estimation-img'
                       loading="lazy"
                       src={require("./workout-feedback-img/not-well-img.png")}
                       width={24}
                       height={24}
                       alt="image feeling not well"/>
                  <span className='feeling-estimation-description'>Nie dobre</span>
                </div>
              </div>
              <div
                onClick={handleChooseItem}
                data-feeling-estimation='I’m OK'
                className='feeling-estimation-item'>
                <div className='feeling-estimation-item__inner'>
                  <img className='feeling-estimation-img'
                       loading="lazy"
                       src={require("./workout-feedback-img/ok-img.png")}
                       width={24}
                       height={24}
                       alt="image feeling ok"/>
                  <span className='feeling-estimation-description'>Som OK</span>
                </div>
              </div>
              <div
                onClick={handleChooseItem}
                data-feeling-estimation='Not tired'
                className='feeling-estimation-item'>
                <div className='feeling-estimation-item__inner'>
                  <img className='feeling-estimation-img'
                       loading="lazy"
                       src={require("./workout-feedback-img/not-tired-img.png")}
                       width={24}
                       height={24}
                       alt="image feeling not tired"/>
                  <span className='feeling-estimation-description'>Nie som unavený</span>
                </div>
              </div>
            </div>
          </div>

          <div ref={workoutContainerRef}
               className='workout-estimation-container'>
            <p className='workout-estimation-title'>Odhadnite náročnosť tréningu pre vás:</p>
            <div ref={workoutEstimationRef}
                 className='workout-estimation-sub-container'>
              <div
                onClick={handleChooseItem}
                data-workout-estimation='Difficult'
                className='workout-estimation-item'>
                <div className='workout-estimation-item__inner'>
                  <img className='workout-estimation-img'
                       loading="lazy"
                       src={require("./workout-feedback-img/not-well-img.png")}
                       width={24}
                       height={24}
                       alt="image workout difficult"/>
                  <span className='workout-estimation-description'>Ťažké</span>
                </div>
              </div>
              <div
                onClick={handleChooseItem}
                data-workout-estimation='Perfect'
                className='workout-estimation-item'>
                <div className='workout-estimation-item__inner'>
                  <img className='workout-estimation-img'
                       loading="lazy"
                       src={require("./workout-feedback-img/ok-img.png")}
                       width={24}
                       height={24}
                       alt="image workout perfect"/>
                  <span className='workout-estimation-description'>Perfektné</span>
                </div>
              </div>
              <div
                onClick={handleChooseItem}
                data-workout-estimation='Too easy'
                className='workout-estimation-item'>
                <div className='workout-estimation-item__inner'>
                  <img className='workout-estimation-img'
                       loading="lazy"
                       src={require("./workout-feedback-img/not-tired-img.png")}
                       width={24}
                       height={24}
                       alt="image workout too easy "/>
                  <span className='workout-estimation-description'>Príliš ľahké</span>
                </div>
              </div>
            </div>
          </div>

          <div ref={heartbeatsContainerRef}
               className='heartbeats-container'>
            <p className='heartbeats-title'>Skontrolujte si pulz</p>
            <div className='heartbeats-sub-container'>
              <div className='heartbeats-sub-container__measurement'>
                <p className='heartbeats-subtitle'>(stlačte tlačidlo "Play" a počítajte údery) </p>
                <div className="heartbeats-input-container">
                  <input ref={inputHeartBeatsRef}
                         className='heartbeats-pulse-input'
                         value={heartBeatsValue}
                         onBlur={handleBlur}
                         onChange={handleChangePulse}
                         type="number"
                         max="3"
                         step="1"
                         placeholder='XXX'
                  />
                  <img className='heartbeats-input-img'
                       loading="lazy"
                       src={require('./workout-feedback-img/edit-pencil.svg').default}
                       alt="image decorative pencil"/>

                  <div ref={pulseInputErrorRef}
                       className="heartbeats-pulse-input--error">
                    Pulz by mal byť aspoň 40 úderov za minútu
                  </div>
                </div>
              </div>
              <div className="heartbeats-sub-container__timer">
                <p className='heartbeats-timer-title'>Odpočítavací časovač</p>
                <TimerHeartbeats duration={60}/>
              </div>
            </div>
          </div>

          <p ref={feedbackErrorRef}
             className='feedback-error'>Prosím, vyplňte všetky polia</p>

          <button className='feedback-btn'
                  onClick={handleSendUserResponse}>
            Pokračovať
          </button>
        </div>
      </div>
      {isPopupShown ? <WorkoutPopupMessage isShown={isPopupShown}/> : null}
    </div>
  )
}

export default WorkoutFeedback;